<template>
  <a-spin
    :spinning="loading === 'loading'"
    class="video-template-list"
  >
    <!-- 消除loading的背景色 -->
    <span v-if="loading === 'loading'"></span>
    <a-empty
      v-if="!dataList.length && loading !== 'loading'"
      :style="{
        margin: '32px 30px 0 0',
        flexGrow: 1,
        opacity: loading === 'loading' ? 0 : 1,
        transition: '.3s',
      }"
      :image="defaultImage"
    />
    <div class="video-clip-custom-list">
      <div
        :key="item.id"
        @click="handleAddTemplate(item.id, item.type)"
        @mouseenter="showPreview(item)"
        @mouseleave="closePreview()"
        class="video-clip-custom-group"
        v-for="(item, index) in dataList"
        v-show="item.is_collect"
      >
        <span @click.stop="starClick(item, index)" class="tem_used_icon" :class="{block: item.is_collect}" :title="item.is_collect?'取消收藏':'收藏'" :style="{'background-image':item.is_collect ? 'url(/preview/icon/icon_collected.png)' : 'url(/preview/icon/icon_collect.png)'}"></span>
        <img
          v-if="item.thumbnail"
          :src="item.thumbnail + '?x-oss-process=image/resize,w_320'"
          alt="Fragment Preview"
          class="video-clip-custom-img"
        />
        <img
          v-else
          class="video-clip-custom-img"
          src="//aivideo8.oss-cn-hongkong.aliyuncs.com/ai_video/U71-2020-05-08-img-1588927160629.png?x-oss-process=image/resize,w_216"
        />
        <button
          class="video-clip-preview"
          type="button"
        >
          <span class="icon iconfont icon-preview"></span>
        </button>
        <div :title="item.name" class="video-clip-custom-title">{{ item.name }}</div>
      </div>
    </div>
  </a-spin>
</template>
<script>
  import { Empty } from 'ant-design-vue';
  import { mapActions } from 'vuex';
  export default {
    props: ['loading', 'dataList'],
    data() {
      return {
        previewTimer: null,
        defaultImage: Empty.PRESENTED_IMAGE_SIMPLE,
      }
    },
    methods: {
      ...mapActions([
        'getTemplateDetail',
        'delCollect',
        'addCollect'
      ]),
      handleAddTemplate(id, type) {
        this.getTemplateDetail({ id, type, toSnippet: true });
      },
      showPreview(item){
        this.previewTimer && clearTimeout(this.previewTimer);
        this.$store.commit("handlePreviewTemplate", item);
      },
      closePreview(){
        this.previewTimer = setTimeout(() => {
          this.$store.commit("handlePreviewTemplate", null);
        }, 1e3)
      },
      // 点击收藏
      async starClick(item, index) {
        if (item.is_collect) {
          // 取消
          await this.delCollect({ type: 'fragment', id: item.id })
          this.$set(item, 'is_collect', false)
        } else {
          // 收藏
          await this.addCollect({ type: 'fragment', id: item.id })
          this.$set(item, 'is_collect', true)
        }
      },
    }
  }
</script>
<style scoped>
.video-clip-custom-group:hover .tem_used_icon, .tem_used_icon.block{
  display: block;
}
.tem_used_icon{
  display: none;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center 0;
  cursor: pointer;
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 1;
}
.video-clip-custom-list {
  width: 248px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  align-content: start;
}

.video-clip-custom-group {
  margin-bottom: 20px;
  cursor: pointer;
  position: relative;
}

.video-clip-custom-img {
  object-fit: cover;
  width: 120px;
  height: 67.5px;
  border-radius: 6px;
}

.video-clip-custom-title {
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  max-width: 120px;
  margin: 9px auto 0 auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.video-clip-preview {
  position: absolute;
  right: 2px;
  bottom: 36px;
  width: 22px;
  height: 16px;
  background: #0009;
  border-radius: 4px;
  justify-content: center;
  margin: 4px 4px 0 0;
  outline: none;
  border: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon-preview{
  font-size: 16px;
  color: #fff;
}

.icon-preview:before {
    content: "\e6b9";
}
</style>